export default __webpack_public_path__ + "static/media/locations_icon.f6115d60.svg";